// Mechanic services list — pricing is "on quote" (per-vehicle assessment).
import { Cog, Wrench, CircleDot, Battery, Zap, Power, HandMetal } from "lucide-react";

export const MECHANIC_SERVICES = [
  { id: "vidange", name: "Vidange", desc: "Huile moteur + filtre à huile", icon: Cog },
  { id: "filtres", name: "Pack filtres", desc: "Air, habitacle, carburant", icon: Wrench },
  { id: "plaquettes", name: "Plaquettes avant", desc: "Pièces + main-d'œuvre", icon: CircleDot },
  { id: "disques_plaquettes", name: "Disques + plaquettes avant", desc: "Freinage neuf complet", icon: CircleDot },
  { id: "batterie", name: "Pose batterie", desc: "Main-d'œuvre, batterie en sus", icon: Battery },
  { id: "demarreur", name: "Démarreur", desc: "Diagnostic + remplacement", icon: Zap },
  { id: "alternateur", name: "Alternateur", desc: "Diagnostic + remplacement", icon: Power },
  { id: "frein_main", name: "Réglage frein à main", desc: "Réglage et contrôle", icon: HandMetal },
];

export const getServiceById = (id) => MECHANIC_SERVICES.find((s) => s.id === id);
